import { useNavigate } from "react-router-dom";
import type { NewsItem } from "@/types/media";
import SectionTitle from "@/components/base/SectionTitle";

export default function NewsPreview({ items }: { items: NewsItem[] }) {
  const navigate = useNavigate();

  return (
    <div>
      <SectionTitle
        icon="ri-newspaper-line"
        title="影视资讯导读"
        subtitle="最新影视新闻、幕后花絮与深度评论"
        moreTo="/news"
        moreLabel="全部资讯"
      />
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
        {items.map((item) => (
          <button
            key={item.id}
            type="button"
            onClick={() => navigate("/news")}
            className="group text-left bg-background-100 rounded-lg overflow-hidden cursor-pointer"
          >
            <div className="w-full h-40 overflow-hidden bg-background-200">
              <img
                src={item.cover}
                alt={item.title}
                title={`${item.title} 影视资讯`}
                className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
            </div>
            <div className="p-4 md:p-5">
              <div className="flex items-center gap-3 text-xs text-foreground-500 mb-2">
                <span className="px-2 py-0.5 rounded-md bg-secondary-100 text-secondary-900">
                  {item.category}
                </span>
                <span className="flex items-center gap-1">
                  <i className="ri-calendar-line"></i>
                  {item.date}
                </span>
              </div>
              <h3 className="font-heading text-base font-semibold text-foreground-950 leading-snug line-clamp-2 group-hover:text-accent-600 transition-colors">
                {item.title}
              </h3>
              <p className="mt-2 text-sm text-foreground-500 leading-relaxed line-clamp-2">
                {item.summary}
              </p>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}